import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogUtils } from '@app/DialogUtils';
import { MessageUtils } from '@app/MessageUtils';
import { UserService } from '@app/services/user/user.service';
import { AppService, LocalStorageService, SessionStorageService } from '@mova/components/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-descarga-carnet',
  templateUrl: './descarga-carnet.component.html',
  styleUrls: ['./descarga-carnet.component.scss']
})
export class DescargaCarnetComponent implements OnInit {
  private txtValid: String;
  private txtNoValid: String;

  downloadPkpass:boolean = false;
  accessDownloadPkpass:boolean = false;

  constructor(private _userService:UserService, private activateRoute: ActivatedRoute,
    private _sessionStorageService:SessionStorageService,
    private router:Router, private _appService: AppService) {}

  //NOTA: Por alguna razón, MOVA recarga la página dos veces por lo que ngOnInit se ejecuta varias veces, se ha implementado esta
  //solución para arreglar el problema que el pkpass se descargue varias veces.
  ngOnInit(): void {
    
    let cdNifNie = this.activateRoute.snapshot.params['cdNifNie'];
    let cdMailUniversidad = this.activateRoute.snapshot.params['cdMailUniversidad'];

    if (this._sessionStorageService.getItem('accessDownloadPkpass') == undefined) {
      this._sessionStorageService.setItem('accessDownloadPkpass', true);

      this._userService.downloadFile(cdNifNie, cdMailUniversidad).subscribe((res) => {
        this.downloadFile(res, cdNifNie);
      }, (error) => {
        if (error) {
          let dialogError = DialogUtils.getDialogError(error ? error : DialogUtils.getDialogPkpassInvalid());
          this._appService.openDialog(dialogError);

        } else {
          this._sessionStorageService.setItem(MessageUtils.LINK_AVAILABLE, 'false');
        }

        this.router.navigate(["login-view"])
      })
    }

    if (this._sessionStorageService.getItem('accessDownloadPkpass') !== undefined) {
      this.accessDownloadPkpass = true;
    }

    if (this._sessionStorageService.getItem('downloadPkpass') !== undefined) {
      this.downloadPkpass = true;
    }

  }

  downloadFile(res, cdNifNie) {
    if (this._sessionStorageService.getItem('downloadPkpass') == undefined) {
      let dataType = res.type;
      let binaryData = [];
      binaryData.push(res);
      let downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
      downloadLink.setAttribute('download', cdNifNie+".pkpass");
      document.body.appendChild(downloadLink);
      downloadLink.click();

    }

    if (this._sessionStorageService.getItem('accessDownloadPkpass') == true) {
      this._sessionStorageService.setItem('downloadPkpass', true);
    }

  }

  ngOnDestroy() {
    this._sessionStorageService.clearItem('downloadPkpass');
  }


}
